const messages = {
    "title": "Manutenção",
    "description": "Atualmente, estão sendo realizados trabalhos de manutenção necessários nos servidores.<br/><br/>Portanto, você atualmente não tem acesso ao <b>BRIDGESTONE <span class=\"text-danger\">PLUS</span></b>.<br/><br/>Pedimos sua paciência e agradecemos sua compreensão.<br/><br/>Sua equipe Bridgestone"
}
export default {
    messages
}
